import clsx from 'clsx';
import chunk from 'lodash/chunk';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useGetCurrentShowroomData } from 'lib/showroom';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';

import ShowroomContainerLayout from 'components/Showroom/ShowroomContainerLayout';

import { useStyles } from './styles';

const ShowroomFooter = () => {
	const showroom = useGetCurrentShowroomData();

	const classes = useStyles();
	const { t } = useTranslation();

	const pdfColumn = React.useMemo(() => {
		const { pdfs, downloadPdfEnabled } = showroom;
		if (!downloadPdfEnabled || isEmpty(pdfs)) return null;
		const columns = chunk(pdfs, 9);
		return (
			<Grid id="showroomFooterPdfsColumns" item md={6} sm={12} xs={12} className={classes.showroomFooterColumn}>
				<span className={classes.showroomFooterSectionTitle}>{t('showroom.footer.pdfs')}</span>
				<Grid container alignItems="flex-start" spacing={4}>
					{columns.map((pdfColumn, index) => (
						<Grid
							id={`showroomFooterPdfsColumn_${index}`}
							key={`showroomFooterPdfsColumn_${index}`}
							item
							container
							direction={'column'}
							sm={6}
							xs={12}
							wrap={'nowrap'}
						>
							{pdfColumn.map(pdf => (
								<Grid id={`showroomFooterPdf_${pdf.publicId}`} key={`showroomFooterPdf_${pdf.publicId}`} item xs={12} zeroMinWidth>
									<a
										id={`showroomFooterPdf_${pdf.publicId}`}
										className={clsx(classes.showroomFooterLink, classes.showroomFooterPdf)}
										href={pdf.publicUrl}
										target="_blank"
										rel="noopener noreferrer"
									>
										<DescriptionOutlinedIcon className={classes.showroomFooterPdfIcon} />
										<Typography className={classes.showroomFooterPdfLabel} component="span" noWrap>
											{pdf.originalFilename}
										</Typography>
									</a>
								</Grid>
							))}
						</Grid>
					))}
				</Grid>
			</Grid>
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showroom, t]);

	return (
		<div id="showroomFooter" className={classes.showroomFooter}>
			<ShowroomContainerLayout containerClasses={{ root: classes.showroomFooterContainer }}>
				<Grid className={classes.showroomFooterGridContainer} container>
					{pdfColumn}
				</Grid>
			</ShowroomContainerLayout>
		</div>
	);
};

export default React.memo(ShowroomFooter);
